var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFilterSet(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.09482 4.54346C1.63004 4.00321 2.01387 3.16666 2.72655 3.16666H13.2736C13.9863 3.16666 14.3701 4.00321 13.9053 4.54346L9.91184 9.18547V12.4943C9.91184 12.7646 9.78075 13.0181 9.56018 13.1743L7.40332 14.7021C6.85144 15.093 6.08831 14.6984 6.08831 14.0221V9.18547L2.09482 4.54346ZM3.08978 4.16666L6.8867 8.58017C7.01677 8.73136 7.08831 8.92419 7.08831 9.12364V13.6998L8.91184 12.4081V9.12364C8.91184 8.92419 8.98337 8.73136 9.11344 8.58017L12.9104 4.16666H3.08978Z",
    fill: "#0A0C1C"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFilterSet);
export default __webpack_public_path__ + "static/media/FilterSet.74bfaaff3c3968c166a12e16a887b85c.svg";
export { ForwardRef as ReactComponent };